import { useContext } from "react";
import { FormContextAMR } from "../form-context";
// import ontarioLogo from "../images/ontario-logo.png";
import medsCheckLogo from "../images/meds-check-logo.png";
import ontarioLeftLogo from "../images/ontario-left-logo.png";
import ontarioPharmaLogo from "../images/ontario-pharma-logo.png";
import { useSelector } from "react-redux";
import { getPharmacistInfo } from "../common/getPharmacyInfo";
import {
  formatToYYYY_MMM_DD,
  formatPhone,
} from "../../../helpers/functions";
import { GetPatientAddress } from "../common/GetPatientAddress";
import { DataField2 } from "../components/common-components";
// import formHeader from "../images/form-header.png";
// PharmacistsWorksheetForm
// ProviderNotification of MedsCheck Services
export const ProviderNotificationForm = () => {
  const formCtx = useContext(FormContextAMR);
  const {
    patient,
    documentation,
    hasActiveInterventions,
  } = formCtx || {};

  const { currentLoggedInUserDetail: userFromCurrentState } = useSelector((state) => state.currentLoggedInUserDetail ?? {});
  const usersState = useSelector((state) => state.users);
  const { currentLoggedInUserDetail: userFromUsers } = usersState ?? {};
  const currentLoggedInUserDetail = userFromCurrentState ?? userFromUsers;
  const pharmacist = getPharmacistInfo(currentLoggedInUserDetail) ?? {};
  const pharmacistName = pharmacist.pharmacistName ?? "";
  const pharmacistSignature = pharmacist.pharmacistSignatureUrl ?? null;

  const isSubmitted = documentation?.isServiceSubmitted === true;
  const confirmation = documentation?.noInterventionConfirmation;
  const hasFollowUpInterventions =
    typeof hasActiveInterventions === "boolean" ? hasActiveInterventions : confirmation === "no";
  const showNoIntervention = isSubmitted && !hasFollowUpInterventions;
  const showIntervention = isSubmitted && hasFollowUpInterventions;

  return (
    <div className="max-w-4xl h-full bg-white mx-auto border-gray-400 ">
      {/* Header with logos */}
      <div className="w-full px-8 py-6">
        <div className="flex justify-between">
          {/* Left side - Ontario logo and ministry info */}
          <div className="flex  space-x-4">
            {/* Ontario Trillium Logo */}
            <div className="flex items-center">
              <img src={ontarioLeftLogo} width="166" height="55" />
            </div>

            {/* Ministry text */}
            <div className="ml-8 self-end text-left">
              <div
                className="text-black font-bold text-xs leading-none tracking-normal"
                style={{
                  fontFamily: "Inter",
                  fontSize: "12px",
                  lineHeight: "100%",
                }}
              >
                Ministry of Health
              </div>
              <div
                className="text-black font-bold text-xs leading-none tracking-normal"
                style={{
                  fontFamily: "Inter",
                  fontSize: "12px",
                  lineHeight: "100%",
                }}
              >
                and Long-Term Care
              </div>
            </div>
          </div>

          {/* Right side - MedsCheck logo */}
          <div className="flex flex-col justify-end items-end">
            <img src={medsCheckLogo} width="196" height="32" />
          </div>
        </div>
      </div>

      <div className="p-6">
        {/* Main Title */}
        <div className="font-bold text-lg leading-none tracking-normal pb-6">
          HealthCare Provider Notification of MedsCheck Services
        </div>

        {/* Table structure */}
        <div className="mb-2">
          <table className="w-full">
            <tbody>
              <tr>
                <td className="pb-3">
                  <DataField2
                    label={"To"}
                    value={
                      <>
                        {documentation?.notificationInformations?.[0]?.lastName || ""}{" "}
                        {documentation?.notificationInformations?.[0]?.firstName || ""}
                      </>
                    }
                  />
                </td>
                <td className="pb-3">
                  <DataField2
                    label={"Fax Number"}
                    value={
                      documentation?.notificationInformations?.[0]?.fax
                        ? `+${
                            documentation?.notificationInformations?.[0]
                              ?.countryCode || "1"
                          } ${formatPhone(
                            documentation?.notificationInformations?.[0]?.fax
                          )}`
                        : ""
                    }
                  />
                </td>
              </tr>
              <tr>
                <td className="pb-3">
                  <DataField2
                    label={"Telephone Number"}
                    value={
                      documentation?.notificationInformations?.[0]?.phoneNumber
                        ? `+${
                            documentation?.notificationInformations?.[0]
                              ?.countryCode || "1"
                          } ${formatPhone(
                            documentation?.notificationInformations?.[0]
                              ?.phoneNumber
                          )}`
                        : ""
                    }
                  />
                </td>
                <td className="pb-3">
                  <DataField2 label={"Pages"} value="" />
                </td>
              </tr>
              <tr>
                <td className="pb-2">
                  <DataField2
                    label={"Email Address"}
                    value={
                      documentation?.notificationInformations?.[0]?.emailAddress || ""
                    }
                  />
                </td>
                <td className="pb-2">
                  <DataField2
                    label={"Date (yyyy/mm/dd)"}
                    value={
                      documentation?.dateOfNotification
                        ? formatToYYYY_MMM_DD(
                            documentation?.dateOfNotification
                          )
                        : ""
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Patient information section */}
        <div className="mb-6">
          <div className="flex mb-4 gap-2">
            <p className="text-sm font-semibold text-gray-800 -mt-1">Re:</p>
            <DataField2
              label={<p className="w-[115px]">Patient's Name</p>}
              value={
                <p className="w-full flex flex-1">
                  {(patient.firstName || "") +
                    (patient.middleName ? ` ${patient.middleName}` : "") +
                    (patient.lastName ? ` ${patient.lastName}` : "")}
                </p>
              }
            />
          </div>

          <div className="ml-8 space-y-3">
            <DataField2
              label={<p className="w-[115px]">Patient's Address</p>}
              value={
                <GetPatientAddress
                  className="!text-xs !font-normal !text-gray-800"
                  showLabel={false}
                  patient={patient}
                />
              }
            />
            <DataField2
              label={<p className="w-[115px]">Telephone Number</p>}
              value={
                patient.contactInfo?.primaryPhone
                  ? `+${
                      patient.contactInfo.primaryPhoneCountryCode
                    } ${formatPhone(patient.contactInfo.primaryPhone)}`
                  : ""
              }
            />
          </div>
        </div>

        {/* Main content */}
        <div className="flex flex-row gap-3 mb-3 font-medium text-sm">
          <div className="items-center gap-4">
            <p className="flex-1">
              Our mutual patient noted above has a meds check completed by our
              pharmacist on
            </p>
          </div>
          <div className="">
            <DataField2
              className={"w-[140px]"}
              label={null}
              value={
                documentation?.dateOfNotification
                  ? formatToYYYY_MMM_DD(documentation?.dateOfNotification)
                  : ""
              }
            />
            <div className="pl-2 text-xs">Date (yyyy/mm/dd)</div>
          </div>
        </div>

        <div className="space-y-2 text-[11px] w-[764px] pb-4 font-medium leading-relaxed">
          <p>
            The MedsCheck program aims to ensure that patients take medications
            as prescribed. It also aims to resolve or prevent any drug therapy
            problems identified by the patient or the pharmacist.
          </p>

          <p>
            The resulting comprehensive MedsCheck Personal Medication Record is
            attached consolidating his/her prescription, non-prescription and
            natural health product profile.
          </p>

          <p>
            This MedsCheck personal medication record is for your reference and
            may be included as part of your patient's ongoing Medical record.
          </p>

          <p className="font-medium">Please see attached</p>
        </div>
        <div className="text-[11px] w-[764px] font-medium leading-relaxed">
          <div className="">Please take note of the following:</div>

          <div className="flex items-start">
            <input
              type="checkbox"
              className="mr-2 mt-0.5 h-3 w-3"
              checked={showNoIntervention}
              readOnly
            />
            <span>
              No follow-up issues have been identified at this time. The
              MedsCheck Personal Medication Record is an accurate assessment of
              the patient's prescription, non-prescription and natural health
              product usage at this current moment.
            </span>
          </div>

          <div className="flex items-start">
            <input
              type="checkbox"
              className="mr-2 mt-0.5 h-3 w-3"
              checked={showIntervention}
              readOnly
            />
            <span>
              Follow up issues have been identified with this meds check review,
              and they have been summarized and are attached with this facts
              transmission.
            </span>
          </div>
        </div>

        <div className="mt-5">
          <table className="w-full border-collapse mb-4">
            <tbody>
              <tr>
                <td colSpan={2} className="border-b pl-1 border-black p-0 align-top">
                  <div className="text-[11px] font-semibold py-1">Issues</div>
                  <div className="h-20 bg-gray-10 p-2">
                    {showIntervention ? (
                      <div className="text-xs text-gray-800">Refer to Clinical Communication Form for Interventions.</div>
                    ) : (
                      <div className="h-full" />
                    )}
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  className="border-t border-b pl-1 border-r border-black p-0 align-top"
                  style={{ width: "50%" }}
                >
                  <div className="text-[11px] font-semibold bg-white py-1">
                    Pharmacist Name
                  </div>
                  <div className="h-6 bg-gray-10 pl-2 pt-1">{pharmacistName}</div>
                </td>
                <td
                  className="border-t border-b pl-1 border-black p-0 align-top"
                  style={{ width: "50%" }}
                >
                  <div className="text-[11px] font-semibold bg-white py-1">
                    Pharmacist’s Signature
                  </div>
                  <div className="h-14 bg-gray-10 pl-2 pt-1">
                    {pharmacistSignature ? (
                      <img
                        src={pharmacistSignature}
                        alt="Pharmacist Signature"
                        className="max-h-10 object-contain"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
         {/* Static footer line with form code and page info */}
         <div className="mt-1 flex w-full text-[9px] text-gray-700">
            <span className="flex-1">
              4976-47E (2022/11) &nbsp; &nbsp; © King&apos;s Printer for Ontario, 2022
            </span>
            <span className="flex-1 text-center">
              <img src={ontarioPharmaLogo} alt="Ontario Pharmacists Association" className="inline-block h-5 w-auto" />
            </span>
            <span className="flex-1 text-right">Page 1 of 1</span>
          </div>
      </div>
    </div>
  );
};
